module.exports = "<div class=\"{classes}\">\n    {#list cells as cell}\n    <span\n        class=\"{this.getCellCls(cell)}\"\n        on-click=\"{this.handleClick(cell, $event)}\"\n        on-mouseenter=\"{this.handleMouseMove(cell)}\"\n    >\n        <em class=\"{prefixCls}-year__cell-em {prefixCls}__cell-em\">{ cell.date.getFullYear() }</em>\n    </span>\n    {/list}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLDate/base/year.table/index.html
// module id = 484
// module chunks = 0